export const LANGUAGES = [
  { code: "id", label: "ID", name: "Indonesia" },
  { code: "en", label: "EN", name: "English" },
  { code: "zh", label: "中文", name: "中文" },
  { code: "ja", label: "JA", name: "日本語" },
  { code: "ko", label: "KO", name: "한국어" },
  { code: "vi", label: "VI", name: "Tiếng Việt" },
  { code: "th", label: "TH", name: "ไทย" },
];

const base = {
  id: {
    nav: { layanan: "Layanan", paket: "Paket", hotel: "Hotel", kontak: "Kontak", cta: "Hubungi Kami" },
    hero: {
      eyebrow: "Travel Agency · Batam, Indonesia",
      title1: "Wonder Often.",
      title2: "Wonder Always.",
      title3: "",
      sub: "Agen travel Batam terpercaya untuk paket tour dari Singapore & Malaysia — tiket ferry, tiket pesawat, hotel, visa, dan Batam Private Tour. Dirancang oleh tim lokal yang paham detail.",
      cta1: "Lihat Paket",
      cta2: "Konsultasi Gratis",
      stat1: "15+ Tahun Pengalaman",
      stat2: "4.9★ Rating",
      stat3: "24/7 Support",
    },
    layanan: {
      eyebrow: "Layanan",
      title: "Perjalanan utuh, satu pintu.",
      sub: "Tiket ferry Batam Singapore, hotel, visa, Batam city tour, dan Batam driver guide — dari rencana awal sampai pulang ke rumah, kami urus semuanya.",
      items: [
        { title: "Tour Package", desc: "Batam tour package, Batam honeymoon package, dan Batam 2 hari 1 malam untuk Bintan & destinasi domestik–internasional." },
        { title: "Tiket Pesawat", desc: "Tiket domestik & international dengan harga bersaing." },
        { title: "Hotel", desc: "Reservasi hotel bintang 3–5 dengan rate khusus agent." },
        { title: "Visa", desc: "Pengurusan visa turis & bisnis ke berbagai negara." },
        { title: "Private Trip", desc: "Batam private tour dengan driver guide profesional dan itinerary custom untuk keluarga, couple, atau korporat." },
      ],
    },
    paket: {
      eyebrow: "Paket Populer",
      title: "Pilihan favorit tamu kami.",
      sub: "Paket tour Batam 1 hari hingga 3 hari 2 malam, termasuk Batam seafood tour dan Batam shopping tour. Harga mulai per orang, tinggal pilih, sisanya biar kami yang siapkan. Cari paket pelancongan Batam dari Malaysia? Kami sedia paket percutian Batam, paket Batam 3 hari 2 malam, dan pilihan tour Batam dari Malaysia yang lengkap. Bagi anda yang mahu melancong ke Batam, guide Batam kami akan bawa anda ke tempat menarik Batam yang terbaik.",
      from: "Mulai",
      perPax: "/pax",
      include: "Termasuk",
      ask: "Tanya",
      book: "Pesan",
      depart: "Berangkat dari",
      off: "OFF",
    },
    hotel: {
      eyebrow: "Hotel di Batam",
      title: "Tidur nyenyak, bangun siap eksplor.",
      sub: "Kurasi hotel mitra kami — dari city hotel sampai resort tepi laut.",
    },
    why: {
      eyebrow: "Kenapa CEO Travel",
      title: "Detil yang bikin liburan terasa mewah.",
      items: [
        { title: "Best Price", desc: "Harga kompetitif, transparan tanpa biaya tersembunyi." },
        { title: "Affordable", desc: "Pilihan paket fleksibel untuk semua budget." },
        { title: "Worldwide", desc: "Jaringan destinasi domestik & internasional." },
        { title: "24/7 Support", desc: "Tim siap bantu kapan pun, di mana pun." },
        { title: "Satisfaction", desc: "Rating 4.9★ dari ribuan tamu puas." },
      ],
    },
    cta: { title: "Siap liburan tanpa ribet?", sub: "Konsultasi gratis via WhatsApp — tim kami balas dalam hitungan menit.", button: "Chat WhatsApp" },
    contact: {
      title: "Kirim Pesan", sub: "Isi form, tim kami hubungi balik. Atau langsung WhatsApp untuk respon cepat.",
      name: "Nama lengkap", email: "Email", phone: "No. WhatsApp (opsional)",
      message: "Tanya apa saja — destinasi, tanggal, jumlah peserta, budget…",
      submit: "Kirim", sending: "Mengirim…",
      success: "Terima kasih! Tim kami akan menghubungi Anda segera.",
      error: "Gagal mengirim. Coba lagi atau hubungi via WhatsApp.",
    },
    quick: {
      pill: "Tanya Cepat", title: "Tanya Cepat", sub: "Isi nama & WhatsApp — tim kami chat balik dalam hitungan menit.",
      name: "Nama", phone: "No. WhatsApp (cth: 628xxxx)", interest: "Paket yang diminati (opsional)",
      submit: "Minta Dihubungi", sending: "Mengirim…",
      success: "Sip! Kami akan WhatsApp Anda sebentar lagi.",
    },
    footer: {
      about: "CEO Travel — partner perjalanan Anda di Batam & dunia. Wonder Often. Wonder Always.",
      contact: "Kontak", follow: "Ikuti Kami",
      address: "Batam – Kepulauan Riau, Indonesia", rights: "Hak cipta dilindungi.",
    },
    waMessages: {
      consult: "Halo CEO Travel, saya tertarik konsultasi paket liburan.",
      ask: (t) => `Halo CEO Travel, saya ingin tanya tentang paket "${t}".`,
      book: (t) => `Halo CEO Travel, saya ingin pesan paket "${t}". Mohon info lebih lanjut.`,
      banner: "Halo CEO Travel, saya siap liburan tanpa ribet!",
    },
  },
  en: {
    nav: { layanan: "Services", paket: "Packages", hotel: "Hotels", kontak: "Contact", cta: "Contact Us" },
    hero: {
      eyebrow: "Travel Agency · Batam, Indonesia",
      title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
      sub: "A trusted Batam travel agency for Batam tour packages and Batam holiday packages from Singapore & Malaysia — ferry tickets, flights, hotels, visas, and Batam private tour experiences. Looking for things to do in Batam? Our local team builds every Batam itinerary with care.",
      cta1: "View Packages", cta2: "Free Consultation",
      stat1: "15+ Years Experience", stat2: "4.9★ Rating", stat3: "24/7 Support",
    },
    layanan: {
      eyebrow: "Services", title: "One door for the whole trip.", sub: "Batam-Singapore ferry tickets, hotels, visas, Batam city tour, and Batam driver guide services — from first idea to safe return, we handle all of it.",
      items: [
        { title: "Tour Package", desc: "Batam tour package, Batam honeymoon package, and Batam 2 days 1 night package options for Bintan & domestic–international destinations." },
        { title: "Flight Tickets", desc: "Domestic & international tickets at competitive rates." },
        { title: "Hotel", desc: "3–5 star hotel bookings with agent-only rates." },
        { title: "Visa", desc: "Tourist & business visa processing worldwide." },
        { title: "Private Trip", desc: "Batam private tour with a local Batam tour guide, private car and private van transport, and custom itinerary — perfect for family & group tour bookings or corporate trips." },
      ],
    },
    paket: {
      eyebrow: "Popular Packages", title: "Guest favourites.", sub: "Batam tour packages from 1-day trips to 3D2N getaways, including Batam seafood tour, seafood dinner, and Batam shopping tour options. Prices starting per person — just pick, we prepare the rest.",
      from: "From", perPax: "/pax", include: "Includes", ask: "Ask", book: "Book", depart: "Departs from", off: "OFF",
    },
    hotel: { eyebrow: "Hotels in Batam", title: "Sleep well, wake up ready.", sub: "Hand-picked partners — from city hotels to beachfront resorts." },
    why: {
      eyebrow: "Why CEO Travel", title: "The little things that make it feel luxurious.",
      items: [
        { title: "Best Price", desc: "Competitive, transparent — no hidden fees." },
        { title: "Affordable", desc: "Flexible packages for every budget." },
        { title: "Worldwide", desc: "Domestic & international destination network." },
        { title: "24/7 Support", desc: "Our team is ready whenever, wherever." },
        { title: "Satisfaction", desc: "4.9★ rating from thousands of happy guests." },
      ],
    },
    cta: { title: "Ready for a stress-free holiday?", sub: "Free WhatsApp consultation — our team replies in minutes.", button: "WhatsApp Us" },
    contact: {
      title: "Send a Message", sub: "Fill the form and our team will get back. Or WhatsApp us for instant reply.",
      name: "Full name", email: "Email", phone: "WhatsApp number (optional)",
      message: "Ask anything — destination, dates, group size, budget…",
      submit: "Send", sending: "Sending…",
      success: "Thank you! Our team will contact you shortly.",
      error: "Failed to send. Please try again or WhatsApp us.",
    },
    quick: {
      pill: "Quick Inquiry", title: "Quick Inquiry", sub: "Drop your name & WhatsApp — our team will chat in minutes.",
      name: "Name", phone: "WhatsApp number (e.g. 628xxxx)", interest: "Package of interest (optional)",
      submit: "Request Callback", sending: "Sending…",
      success: "Done! We'll WhatsApp you in a moment.",
    },
    footer: {
      about: "CEO Travel — your travel partner in Batam and beyond. Wonder Often. Wonder Always.",
      contact: "Contact", follow: "Follow Us", address: "Batam – Riau Islands, Indonesia", rights: "All rights reserved.",
    },
    waMessages: {
      consult: "Hello CEO Travel, I'd like a free consultation about your packages.",
      ask: (t) => `Hello CEO Travel, I have a question about the "${t}" package.`,
      book: (t) => `Hello CEO Travel, I'd like to book the "${t}" package. Please send more info.`,
      banner: "Hello CEO Travel, I'm ready for a stress-free trip!",
    },
  },
  zh: {
    nav: { layanan: "服务", paket: "套餐", hotel: "酒店", kontak: "联系", cta: "联系我们" },
    hero: {
      eyebrow: "旅行社 · 印尼巴淡岛",
      title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
      sub: "新加坡与马来西亚出发巴淡岛精选套餐 — 机票、酒店、签证、私人定制。本地团队，细节用心。",
      cta1: "查看套餐", cta2: "免费咨询",
      stat1: "15+ 年经验", stat2: "4.9★ 评分", stat3: "24/7 客服",
    },
    layanan: {
      eyebrow: "服务", title: "一站式旅行管家。", sub: "从计划到归来，我们全程包办。",
      items: [
        { title: "旅游套餐", desc: "巴淡岛、民丹岛及国内外旅游套餐。" },
        { title: "机票", desc: "国内外机票，价格优势。" },
        { title: "酒店预订", desc: "3–5 星级酒店专属代理价。" },
        { title: "签证办理", desc: "全球旅游与商务签证代办。" },
        { title: "私人定制", desc: "家庭、情侣、企业专属行程。" },
      ],
    },
    paket: {
      eyebrow: "热门套餐", title: "客人最爱之选。", sub: "每人起价，挑好后其它交给我们。",
      from: "起价", perPax: "/人", include: "包含", ask: "咨询", book: "预订", depart: "出发地", off: "OFF",
    },
    hotel: { eyebrow: "巴淡岛酒店", title: "睡得好，玩得尽兴。", sub: "精挑细选的合作酒店 — 从市区到海滨度假村。" },
    why: {
      eyebrow: "为什么选择 CEO Travel", title: "细节让旅程更尊贵。",
      items: [
        { title: "最优价格", desc: "价格透明，没有隐藏费用。" },
        { title: "灵活预算", desc: "套餐多样，适合各种预算。" },
        { title: "全球覆盖", desc: "国内外目的地网络齐全。" },
        { title: "24/7 客服", desc: "随时随地，我们在线。" },
        { title: "客户满意", desc: "数千客人 4.9★ 好评。" },
      ],
    },
    cta: { title: "想轻松出游？", sub: "WhatsApp 免费咨询 — 我们几分钟内回复。", button: "WhatsApp 联系" },
    contact: {
      title: "留言咨询", sub: "填写表格我们会联系您，或 WhatsApp 直接咨询。",
      name: "姓名", email: "邮箱", phone: "WhatsApp 号码（可选）",
      message: "随便问 — 目的地、日期、人数、预算……",
      submit: "发送", sending: "发送中…",
      success: "感谢您的留言！我们会尽快联系您。",
      error: "发送失败，请重试或 WhatsApp 联系。",
    },
    quick: {
      pill: "快速咨询", title: "快速咨询", sub: "留下姓名和 WhatsApp，团队几分钟内联系您。",
      name: "姓名", phone: "WhatsApp 号码（如 628xxxx）", interest: "感兴趣的套餐（可选）",
      submit: "请联系我", sending: "发送中…",
      success: "好的！我们会马上 WhatsApp 您。",
    },
    footer: {
      about: "CEO Travel — 您的巴淡岛及全球旅行伙伴。Wonder Often. Wonder Always.",
      contact: "联系方式", follow: "关注我们", address: "印尼廖内群岛 巴淡岛", rights: "版权所有。",
    },
    waMessages: {
      consult: "您好 CEO Travel，我想免费咨询旅游套餐。",
      ask: (t) => `您好 CEO Travel，我想咨询 "${t}" 套餐。`,
      book: (t) => `您好 CEO Travel，我想预订 "${t}" 套餐，请发更多详情。`,
      banner: "您好 CEO Travel，我准备好轻松出游了！",
    },
  },
  ja: {
    nav: { layanan: "サービス", paket: "パッケージ", hotel: "ホテル", kontak: "お問合せ", cta: "お問い合わせ" },
    hero: {
      eyebrow: "旅行代理店 · インドネシア・バタム島",
      title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
      sub: "シンガポール・マレーシア発のバタム島ツアー — 航空券、ホテル、ビザ、プライベートトリップ。細部にこだわる現地チームが企画。",
      cta1: "パッケージを見る", cta2: "無料相談",
      stat1: "経験 15年以上", stat2: "★4.9 評価", stat3: "24時間サポート",
    },
    layanan: {
      eyebrow: "サービス", title: "旅のすべてをワンストップで。", sub: "計画から帰国まで、すべて私たちにお任せ。",
      items: [
        { title: "ツアーパッケージ", desc: "バタム島、ビンタン島、国内外ツアー。" },
        { title: "航空券", desc: "国内・国際線、競争力のある価格。" },
        { title: "ホテル", desc: "3〜5つ星ホテル、代理店特別レート。" },
        { title: "ビザ", desc: "世界各国の観光・ビジネスビザ手配。" },
        { title: "プライベート", desc: "家族・カップル・法人向けカスタム旅程。" },
      ],
    },
    paket: {
      eyebrow: "人気パッケージ", title: "ゲストに選ばれた旅。", sub: "お一人様価格。選ぶだけ、あとはお任せ。",
      from: "から", perPax: "/人", include: "含まれるもの", ask: "問合せ", book: "予約", depart: "出発地", off: "OFF",
    },
    hotel: { eyebrow: "バタムのホテル", title: "ぐっすり眠って、思いきり遊ぶ。", sub: "厳選パートナーホテル — 市内からビーチリゾートまで。" },
    why: {
      eyebrow: "CEO Travel を選ぶ理由", title: "細部こそ、贅沢を生む。",
      items: [
        { title: "ベスト価格", desc: "競争力ある料金、隠れた費用なし。" },
        { title: "柔軟な予算", desc: "あらゆる予算に応じたプラン。" },
        { title: "世界中対応", desc: "国内外の目的地ネットワーク。" },
        { title: "24時間対応", desc: "いつでもどこでも対応します。" },
        { title: "高い満足度", desc: "数千人のゲストから★4.9。" },
      ],
    },
    cta: { title: "気軽に旅行に出かけませんか？", sub: "WhatsApp 無料相談 — 数分で返信。", button: "WhatsAppで連絡" },
    contact: {
      title: "メッセージを送る", sub: "フォーム送信、または WhatsApp ですぐに連絡。",
      name: "お名前", email: "メールアドレス", phone: "WhatsApp 番号（任意）",
      message: "目的地、日付、人数、ご予算など、自由にお問い合わせください。",
      submit: "送信", sending: "送信中…",
      success: "ありがとうございます！担当者がすぐにご連絡します。",
      error: "送信に失敗しました。再度お試しいただくか WhatsApp でご連絡ください。",
    },
    quick: {
      pill: "クイック問合せ", title: "クイック問合せ", sub: "お名前と WhatsApp を入力 — 数分でご連絡します。",
      name: "お名前", phone: "WhatsApp 番号（例: 628xxxx）", interest: "ご興味のあるパッケージ（任意）",
      submit: "折返しを依頼", sending: "送信中…",
      success: "承りました！すぐに WhatsApp でご連絡します。",
    },
    footer: {
      about: "CEO Travel — バタム島と世界の旅のパートナー。Wonder Often. Wonder Always.",
      contact: "連絡先", follow: "フォローする", address: "インドネシア リアウ諸島 バタム島", rights: "All rights reserved.",
    },
    waMessages: {
      consult: "こんにちは、CEO Travel さん。パッケージについて無料相談を希望します。",
      ask: (t) => `こんにちは、CEO Travel さん。「${t}」パッケージについて質問があります。`,
      book: (t) => `こんにちは、CEO Travel さん。「${t}」パッケージを予約したいです。詳細をお願いします。`,
      banner: "こんにちは、CEO Travel さん。気軽な旅行に出かけたいです！",
    },
  },
  ko: {
    nav: { layanan: "서비스", paket: "패키지", hotel: "호텔", kontak: "연락처", cta: "문의하기" },
    hero: {
      eyebrow: "여행사 · 인도네시아 바탐섬",
      title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
      sub: "싱가포르·말레이시아 출발 바탐 패키지 — 항공권, 호텔, 비자, 프라이빗 투어. 디테일에 집중하는 현지 팀이 설계.",
      cta1: "패키지 보기", cta2: "무료 상담",
      stat1: "경력 15년+", stat2: "4.9★ 평점", stat3: "24/7 지원",
    },
    layanan: {
      eyebrow: "서비스", title: "여행의 모든 것을 한곳에서.", sub: "계획부터 귀국까지, 저희가 모두 처리합니다.",
      items: [
        { title: "투어 패키지", desc: "바탐, 빈탄 및 국내외 투어 패키지." },
        { title: "항공권", desc: "국내·국제선, 경쟁력 있는 가격." },
        { title: "호텔", desc: "3~5성 호텔, 에이전트 전용 요금." },
        { title: "비자", desc: "전 세계 관광·비즈니스 비자 처리." },
        { title: "프라이빗", desc: "가족·커플·기업 맞춤 일정." },
      ],
    },
    paket: {
      eyebrow: "인기 패키지", title: "고객이 선택한 베스트.", sub: "1인 기준 시작가. 고르기만 하세요.",
      from: "시작가", perPax: "/인", include: "포함 사항", ask: "문의", book: "예약", depart: "출발지", off: "OFF",
    },
    hotel: { eyebrow: "바탐 호텔", title: "푹 자고, 신나게 즐기자.", sub: "엄선된 파트너 호텔 — 시내부터 해변 리조트까지." },
    why: {
      eyebrow: "왜 CEO Travel?", title: "디테일이 럭셔리를 만든다.",
      items: [
        { title: "최저가", desc: "경쟁력 있는 투명 요금." },
        { title: "유연한 예산", desc: "모든 예산에 맞는 패키지." },
        { title: "전 세계", desc: "국내외 목적지 네트워크." },
        { title: "24/7 지원", desc: "언제 어디서나 도와드립니다." },
        { title: "높은 만족도", desc: "수천 고객의 4.9★ 평점." },
      ],
    },
    cta: { title: "스트레스 없는 휴가, 떠나볼까요?", sub: "WhatsApp 무료 상담 — 몇 분 안에 답변.", button: "WhatsApp 문의" },
    contact: {
      title: "메시지 보내기", sub: "양식 작성 또는 WhatsApp 으로 바로 문의하세요.",
      name: "성함", email: "이메일", phone: "WhatsApp 번호 (선택)",
      message: "목적지, 날짜, 인원, 예산 등 자유롭게 문의하세요.",
      submit: "보내기", sending: "전송 중…",
      success: "감사합니다! 곧 연락드리겠습니다.",
      error: "전송에 실패했습니다. 다시 시도하거나 WhatsApp 으로 연락주세요.",
    },
    quick: {
      pill: "빠른 문의", title: "빠른 문의", sub: "이름과 WhatsApp 만 — 팀이 몇 분 안에 연락드립니다.",
      name: "이름", phone: "WhatsApp 번호 (예: 628xxxx)", interest: "관심 패키지 (선택)",
      submit: "연락 요청", sending: "전송 중…",
      success: "완료! 곧 WhatsApp 으로 연락드리겠습니다.",
    },
    footer: {
      about: "CEO Travel — 바탐과 세계의 여행 파트너. Wonder Often. Wonder Always.",
      contact: "연락처", follow: "팔로우", address: "인도네시아 리아우 제도 바탐", rights: "모든 권리 보유.",
    },
    waMessages: {
      consult: "안녕하세요 CEO Travel, 패키지에 대해 무료 상담을 받고 싶습니다.",
      ask: (t) => `안녕하세요 CEO Travel, "${t}" 패키지에 대해 질문이 있습니다.`,
      book: (t) => `안녕하세요 CEO Travel, "${t}" 패키지를 예약하고 싶습니다. 자세한 정보를 보내주세요.`,
      banner: "안녕하세요 CEO Travel, 스트레스 없는 여행을 떠나고 싶습니다!",
    },
  },
};

// Inject `destinations` namespace into each language (compact, EN fallback if missing)
const destTitles = {
  id: { eyebrow: "Destinasi", title: "Dunia, kami bawa ke Batam.", sub: "Dari Singapura, Malaysia, China, Jepang, Korea, Vietnam hingga Thailand — kami atur perjalanan tamu menuju Batam dari berbagai negara." },
  en: { eyebrow: "Destinations", title: "Bringing the world to Batam.", sub: "From Singapore, Malaysia, China, Japan, Korea, Vietnam to Thailand — we arrange itineraries for travellers heading to Batam." },
  zh: { eyebrow: "目的地", title: "把世界带到巴淡岛。", sub: "从新加坡、马来西亚、中国、日本、韩国、越南到泰国 — 我们为前往巴淡岛的旅客安排行程。" },
  ja: { eyebrow: "目的地", title: "世界をバタムへ。", sub: "シンガポール、マレーシア、中国、日本、韓国、ベトナム、タイから — バタムを訪れる旅行者のための旅程を手配します。" },
  ko: { eyebrow: "여행지", title: "세계를 바탐으로.", sub: "싱가포르, 말레이시아, 중국, 일본, 한국, 베트남, 태국에서 — 바탐으로 향하는 여행객을 위한 일정을 준비합니다." },
  vi: { eyebrow: "Điểm đến", title: "Mang thế giới đến Batam.", sub: "Từ Singapore, Malaysia, Trung Quốc, Nhật Bản, Hàn Quốc, Việt Nam đến Thái Lan — chúng tôi sắp xếp hành trình cho du khách đến Batam." },
  th: { eyebrow: "จุดหมายปลายทาง", title: "พาทั้งโลกมาที่บาตัม", sub: "จากสิงคโปร์ มาเลเซีย จีน ญี่ปุ่น เกาหลี เวียดนาม และไทย — เราจัดทริปสำหรับนักเดินทางที่มุ่งหน้าสู่บาตัม" },
};
Object.keys(destTitles).forEach((k) => {
  if (base[k]) base[k].destinations = destTitles[k];
});

// Inject `paket.detail` labels used by PackageDetailModal
const detailLabels = {
  id: { overview: "Overview", itinerary: "Itinerary", inclusions: "Termasuk", exclusions: "Tidak Termasuk", gallery: "Galeri", day: "Hari", duration: "Durasi", departFrom: "Berangkat dari", priceFrom: "Mulai dari", perPax: "/orang", bookWa: "Pesan via WhatsApp", payOnline: "Bayar Online", payOnlineSoon: "Bayar Online (Segera Hadir)", askMore: "Tanya Detail", close: "Tutup", saveAmount: "Hemat", whatYouGet: "Apa yang Anda dapatkan", notes: "Catatan: harga per orang berdasarkan minimum 4 peserta. Hubungi kami untuk grup lebih kecil atau private trip." },
  en: { overview: "Overview", itinerary: "Itinerary", inclusions: "What's Included", exclusions: "Not Included", gallery: "Gallery", day: "Day", duration: "Duration", departFrom: "Departs From", priceFrom: "Starting From", perPax: "/person", bookWa: "Book via WhatsApp", payOnline: "Pay Online", payOnlineSoon: "Pay Online (Coming Soon)", askMore: "Ask Details", close: "Close", saveAmount: "Save", whatYouGet: "What you get", notes: "Note: prices are per person based on a minimum of 4 pax. Contact us for smaller groups or private trips." },
  zh: { overview: "概览", itinerary: "行程", inclusions: "包含项目", exclusions: "不包含", gallery: "图集", day: "第", duration: "时长", departFrom: "出发地", priceFrom: "起价", perPax: "/人", bookWa: "WhatsApp 预订", payOnline: "在线支付", payOnlineSoon: "在线支付（即将开放）", askMore: "咨询详情", close: "关闭", saveAmount: "省", whatYouGet: "您将享有", notes: "注意：价格为每人，基于最少4位参加者。如需小团或私人定制请联系我们。" },
  ja: { overview: "概要", itinerary: "旅程", inclusions: "含まれるもの", exclusions: "含まれないもの", gallery: "ギャラリー", day: "日目", duration: "期間", departFrom: "出発地", priceFrom: "から", perPax: "/人", bookWa: "WhatsApp で予約", payOnline: "オンライン決済", payOnlineSoon: "オンライン決済（近日公開）", askMore: "詳細を問合せ", close: "閉じる", saveAmount: "お得", whatYouGet: "得られるもの", notes: "注：料金はお一人様、最低4名様基準です。少人数やプライベートはお問合せください。" },
  ko: { overview: "개요", itinerary: "일정", inclusions: "포함 사항", exclusions: "불포함", gallery: "갤러리", day: "일차", duration: "기간", departFrom: "출발지", priceFrom: "시작가", perPax: "/인", bookWa: "WhatsApp 예약", payOnline: "온라인 결제", payOnlineSoon: "온라인 결제 (출시 예정)", askMore: "자세히 문의", close: "닫기", saveAmount: "할인", whatYouGet: "제공 사항", notes: "참고: 가격은 1인 기준이며 최소 4인부터입니다. 소규모/프라이빗은 문의해주세요." },
  vi: { overview: "Tổng quan", itinerary: "Lịch trình", inclusions: "Bao gồm", exclusions: "Không bao gồm", gallery: "Hình ảnh", day: "Ngày", duration: "Thời lượng", departFrom: "Khởi hành từ", priceFrom: "Từ", perPax: "/khách", bookWa: "Đặt qua WhatsApp", payOnline: "Thanh toán Online", payOnlineSoon: "Thanh toán Online (Sắp ra mắt)", askMore: "Hỏi chi tiết", close: "Đóng", saveAmount: "Tiết kiệm", whatYouGet: "Bạn nhận được gì", notes: "Lưu ý: giá theo mỗi khách, tối thiểu 4 khách. Liên hệ chúng tôi cho nhóm nhỏ hoặc tour riêng." },
  th: { overview: "ภาพรวม", itinerary: "กำหนดการ", inclusions: "รวมในแพ็กเกจ", exclusions: "ไม่รวมในแพ็กเกจ", gallery: "แกลเลอรี", day: "วันที่", duration: "ระยะเวลา", departFrom: "ออกเดินทางจาก", priceFrom: "เริ่มต้น", perPax: "/ท่าน", bookWa: "จองทาง WhatsApp", payOnline: "ชำระเงินออนไลน์", payOnlineSoon: "ชำระเงินออนไลน์ (เร็วๆ นี้)", askMore: "สอบถามรายละเอียด", close: "ปิด", saveAmount: "ประหยัด", whatYouGet: "สิ่งที่คุณจะได้", notes: "หมายเหตุ: ราคาต่อท่าน คำนวณจาก 4 ท่านขึ้นไป สำหรับกลุ่มเล็กหรือทัวร์ส่วนตัวกรุณาติดต่อเรา" },
};
Object.keys(detailLabels).forEach((k) => {
  if (base[k] && base[k].paket) base[k].paket.detail = detailLabels[k];
});

// Compact VI + TH translations (other keys cloned from EN as graceful fallback)
const enClone = JSON.parse(JSON.stringify(base.en));
// Restore function refs that JSON.stringify drops
enClone.waMessages = base.en.waMessages;

base.vi = {
  ...enClone,
  nav: { layanan: "Dịch vụ", paket: "Gói tour", hotel: "Khách sạn", kontak: "Liên hệ", cta: "Liên hệ" },
  hero: {
    ...enClone.hero,
    eyebrow: "Công ty du lịch · Batam, Indonesia",
    title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
    sub: "Gói Batam từ Singapore & Malaysia — vé máy bay, khách sạn, visa, tour riêng. Đội ngũ địa phương tỉ mỉ từng chi tiết.",
    cta1: "Xem gói tour", cta2: "Tư vấn miễn phí",
    stat1: "Hơn 15 năm kinh nghiệm", stat2: "Đánh giá 4.9★", stat3: "Hỗ trợ 24/7",
  },
  paket: { ...enClone.paket, eyebrow: "Gói phổ biến", title: "Lựa chọn yêu thích.", from: "Từ", perPax: "/khách", include: "Bao gồm", ask: "Hỏi", book: "Đặt", depart: "Khởi hành từ", off: "GIẢM" },
  hotel: { eyebrow: "Khách sạn tại Batam", title: "Ngủ ngon, sẵn sàng khám phá.", sub: "Khách sạn đối tác được tuyển chọn." },
  cta: { title: "Sẵn sàng cho kỳ nghỉ thư thái?", sub: "Tư vấn WhatsApp miễn phí — phản hồi trong vài phút.", button: "Nhắn WhatsApp" },
  quick: { pill: "Hỏi nhanh", title: "Hỏi nhanh", sub: "Để lại tên & WhatsApp — chúng tôi sẽ liên hệ trong vài phút.", name: "Tên", phone: "Số WhatsApp (vd: 628xxxx)", interest: "Gói quan tâm (tùy chọn)", submit: "Yêu cầu gọi lại", sending: "Đang gửi…", success: "Đã ghi nhận! Chúng tôi sẽ WhatsApp ngay." },
  footer: { ...enClone.footer, about: "CEO Travel — đối tác du lịch tại Batam và toàn cầu. Wonder Often. Wonder Always.", contact: "Liên hệ", follow: "Theo dõi", address: "Batam – Quần đảo Riau, Indonesia", rights: "Bản quyền được bảo lưu." },
  destinations: destTitles.vi,
  waMessages: {
    consult: "Xin chào CEO Travel, tôi muốn được tư vấn miễn phí về các gói tour.",
    ask: (t) => `Xin chào CEO Travel, tôi muốn hỏi về gói "${t}".`,
    book: (t) => `Xin chào CEO Travel, tôi muốn đặt gói "${t}". Vui lòng gửi thêm thông tin.`,
    banner: "Xin chào CEO Travel, tôi sẵn sàng cho một chuyến đi thư thái!",
  },
};

base.th = {
  ...enClone,
  nav: { layanan: "บริการ", paket: "แพ็กเกจ", hotel: "โรงแรม", kontak: "ติดต่อ", cta: "ติดต่อเรา" },
  hero: {
    ...enClone.hero,
    eyebrow: "บริษัททัวร์ · บาตัม อินโดนีเซีย",
    title1: "Wonder Often.", title2: "Wonder Always.", title3: "",
    sub: "แพ็กเกจบาตัมจากสิงคโปร์และมาเลเซีย — ตั๋วเครื่องบิน โรงแรม วีซ่า ทัวร์ส่วนตัว ออกแบบโดยทีมท้องถิ่นที่ใส่ใจทุกรายละเอียด",
    cta1: "ดูแพ็กเกจ", cta2: "ปรึกษาฟรี",
    stat1: "ประสบการณ์ 15+ ปี", stat2: "เรตติ้ง 4.9★", stat3: "ซัพพอร์ต 24/7",
  },
  paket: { ...enClone.paket, eyebrow: "แพ็กเกจยอดนิยม", title: "ตัวเลือกที่ลูกค้าชื่นชอบ", from: "เริ่มต้น", perPax: "/ท่าน", include: "รวม", ask: "สอบถาม", book: "จอง", depart: "ออกจาก", off: "ส่วนลด" },
  hotel: { eyebrow: "โรงแรมในบาตัม", title: "หลับสบาย ตื่นมาพร้อมเที่ยว", sub: "โรงแรมคู่ค้าคัดสรร" },
  cta: { title: "พร้อมพักผ่อนแบบไม่ต้องคิดมากหรือยัง?", sub: "ปรึกษาฟรีทาง WhatsApp — ตอบกลับใน 2-3 นาที", button: "แชต WhatsApp" },
  quick: { pill: "สอบถามด่วน", title: "สอบถามด่วน", sub: "ทิ้งชื่อและ WhatsApp ไว้ ทีมเราจะติดต่อกลับใน 2-3 นาที", name: "ชื่อ", phone: "เบอร์ WhatsApp (เช่น 628xxxx)", interest: "แพ็กเกจที่สนใจ (ไม่บังคับ)", submit: "ขอให้ติดต่อกลับ", sending: "กำลังส่ง…", success: "เรียบร้อย! ทีมเราจะ WhatsApp คุณเร็วๆ นี้" },
  footer: { ...enClone.footer, about: "CEO Travel — พาร์ทเนอร์การเดินทางในบาตัมและทั่วโลก Wonder Often. Wonder Always.", contact: "ติดต่อ", follow: "ติดตามเรา", address: "บาตัม – หมู่เกาะเรียว อินโดนีเซีย", rights: "สงวนลิขสิทธิ์" },
  destinations: destTitles.th,
  waMessages: {
    consult: "สวัสดีค่ะ/ครับ CEO Travel ฉันต้องการปรึกษาเกี่ยวกับแพ็กเกจฟรี",
    ask: (t) => `สวัสดี CEO Travel ฉันมีคำถามเกี่ยวกับแพ็กเกจ "${t}"`,
    book: (t) => `สวัสดี CEO Travel ฉันต้องการจองแพ็กเกจ "${t}" กรุณาส่งรายละเอียดเพิ่มเติม`,
    banner: "สวัสดี CEO Travel ฉันพร้อมไปเที่ยวแบบไร้กังวลแล้ว!",
  },
};

export const translations = base;
// Apply paket.detail for vi/th (constructed after detailLabels injection runs)
if (base.vi?.paket && detailLabels.vi) base.vi.paket.detail = detailLabels.vi;
if (base.th?.paket && detailLabels.th) base.th.paket.detail = detailLabels.th;

// Booking flow labels
const bookingLabels = {
  id: { title: "Pesan Paket", step1: "Tanggal & Peserta", step2: "Data Pemesan", step3: "Konfirmasi", step4: "Booking Diterima", startDate: "Tanggal Berangkat", endDate: "Tanggal Pulang", adults: "Dewasa", children: "Anak", child_age: "(2-11 thn)", name: "Nama Lengkap", email: "Email", phone: "WhatsApp", country: "Negara", notes: "Catatan (opsional)", next: "Lanjut", back: "Kembali", confirm: "Konfirmasi & Bayar Nanti", reviewTitle: "Review Pesanan Anda", package: "Paket", dates: "Tanggal", pax: "Peserta", total: "Total Harga", success: "Booking berhasil dibuat!", successDesc: "Tim kami akan menghubungi Anda dalam 1×24 jam untuk konfirmasi & pembayaran.", bookingId: "ID Booking", wa_followup: "Hubungi via WhatsApp", payOnlineSoon: "Bayar Online (Segera Hadir)", required: "Wajib diisi", invalidEmail: "Email tidak valid", submitting: "Memproses..." },
  en: { title: "Book Package", step1: "Date & Pax", step2: "Your Info", step3: "Review", step4: "Booking Received", startDate: "Departure Date", endDate: "Return Date", adults: "Adults", children: "Children", child_age: "(2-11 yrs)", name: "Full Name", email: "Email", phone: "WhatsApp", country: "Country", notes: "Notes (optional)", next: "Next", back: "Back", confirm: "Confirm & Pay Later", reviewTitle: "Review Your Order", package: "Package", dates: "Dates", pax: "Guests", total: "Total", success: "Booking confirmed!", successDesc: "Our team will contact you within 24h for confirmation & payment.", bookingId: "Booking ID", wa_followup: "Continue on WhatsApp", payOnlineSoon: "Pay Online (Coming Soon)", required: "Required", invalidEmail: "Invalid email", submitting: "Submitting..." },
  zh: { title: "预订套餐", step1: "日期与人数", step2: "您的信息", step3: "确认", step4: "预订已接收", startDate: "出发日期", endDate: "返回日期", adults: "成人", children: "儿童", child_age: "(2-11岁)", name: "全名", email: "邮箱", phone: "WhatsApp", country: "国家", notes: "备注（可选）", next: "下一步", back: "返回", confirm: "确认 & 稍后付款", reviewTitle: "确认订单", package: "套餐", dates: "日期", pax: "人数", total: "总价", success: "预订成功！", successDesc: "我们的团队将在24小时内联系您确认付款。", bookingId: "订单号", wa_followup: "继续 WhatsApp 沟通", payOnlineSoon: "在线支付（即将开放）", required: "必填", invalidEmail: "邮箱无效", submitting: "提交中..." },
  ja: { title: "パッケージを予約", step1: "日程と人数", step2: "お客様情報", step3: "確認", step4: "予約受付完了", startDate: "出発日", endDate: "帰着日", adults: "大人", children: "子供", child_age: "(2-11歳)", name: "氏名", email: "メール", phone: "WhatsApp", country: "国", notes: "備考（任意）", next: "次へ", back: "戻る", confirm: "確定して後で支払う", reviewTitle: "ご予約内容の確認", package: "パッケージ", dates: "日程", pax: "人数", total: "合計", success: "予約完了！", successDesc: "24時間以内に確認とお支払いについてご連絡いたします。", bookingId: "予約番号", wa_followup: "WhatsApp で続ける", payOnlineSoon: "オンライン決済（近日公開）", required: "必須", invalidEmail: "メール無効", submitting: "送信中..." },
  ko: { title: "패키지 예약", step1: "날짜 및 인원", step2: "고객 정보", step3: "확인", step4: "예약 완료", startDate: "출발일", endDate: "도착일", adults: "성인", children: "어린이", child_age: "(2-11세)", name: "이름", email: "이메일", phone: "WhatsApp", country: "국가", notes: "메모 (선택)", next: "다음", back: "뒤로", confirm: "확정 후 결제", reviewTitle: "예약 확인", package: "패키지", dates: "날짜", pax: "인원", total: "총액", success: "예약 완료!", successDesc: "24시간 이내에 팀이 확인 연락을 드립니다.", bookingId: "예약 번호", wa_followup: "WhatsApp 으로 계속", payOnlineSoon: "온라인 결제 (출시 예정)", required: "필수", invalidEmail: "이메일 오류", submitting: "전송 중..." },
  vi: { title: "Đặt Tour", step1: "Ngày & Khách", step2: "Thông tin", step3: "Xác nhận", step4: "Đã nhận", startDate: "Ngày khởi hành", endDate: "Ngày về", adults: "Người lớn", children: "Trẻ em", child_age: "(2-11 tuổi)", name: "Họ tên", email: "Email", phone: "WhatsApp", country: "Quốc gia", notes: "Ghi chú (tùy chọn)", next: "Tiếp", back: "Quay lại", confirm: "Xác nhận & Thanh toán sau", reviewTitle: "Xác nhận đơn", package: "Gói tour", dates: "Ngày", pax: "Khách", total: "Tổng", success: "Đặt tour thành công!", successDesc: "Đội ngũ sẽ liên hệ trong 24h để xác nhận & thanh toán.", bookingId: "Mã booking", wa_followup: "Tiếp tục qua WhatsApp", payOnlineSoon: "Thanh toán Online (Sắp ra mắt)", required: "Bắt buộc", invalidEmail: "Email không hợp lệ", submitting: "Đang gửi..." },
  th: { title: "จองแพ็กเกจ", step1: "วันที่ & ผู้เข้าร่วม", step2: "ข้อมูลผู้จอง", step3: "ยืนยัน", step4: "รับการจองแล้ว", startDate: "วันออกเดินทาง", endDate: "วันกลับ", adults: "ผู้ใหญ่", children: "เด็ก", child_age: "(2-11 ปี)", name: "ชื่อ-นามสกุล", email: "อีเมล", phone: "WhatsApp", country: "ประเทศ", notes: "หมายเหตุ (ไม่บังคับ)", next: "ถัดไป", back: "กลับ", confirm: "ยืนยัน & ชำระเงินภายหลัง", reviewTitle: "ตรวจสอบรายการ", package: "แพ็กเกจ", dates: "วันที่", pax: "ผู้เข้าร่วม", total: "รวม", success: "จองสำเร็จ!", successDesc: "ทีมจะติดต่อภายใน 24 ชม. เพื่อยืนยันและชำระเงิน", bookingId: "หมายเลขการจอง", wa_followup: "ติดต่อทาง WhatsApp", payOnlineSoon: "ชำระออนไลน์ (เร็วๆ นี้)", required: "จำเป็น", invalidEmail: "อีเมลไม่ถูกต้อง", submitting: "กำลังส่ง..." },
};
Object.keys(bookingLabels).forEach((k) => {
  if (base[k]) base[k].booking = bookingLabels[k];
});
